<s1-input-label [label]="label">
  <input class="form-control" *ngIf="!readonly" [ngClass]="{'is-invalid' : !checkIsValid() }" type="text" bsDatepicker [bsConfig]="bsConfig" [formControl]="control" [readonly]="readonly" />
  <input class="form-control" *ngIf="readonly" [ngClass]="{'is-invalid' : !checkIsValid() }" type="text" [value]="readableDate()" [readonly]="true" />
</s1-input-label>